export const CONFIRMATION_CODE_LENGTH = 6;
export enum CustomAttributes {
  HomeDevices = 'custom:devices',
  TestGroups = 'custom:testGroups',
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/authClient/constants.ts